import { downloadApk } from '../../../utils/downloadApk';

export function ExclusiveGamesSection() {
  return (
    <section className="bg-darker py-16 md:py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-3 mb-8 md:mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-serif font-black mb-1 md:mb-2">Exclusive Originals</h2>
            <p className="text-slate-400 text-sm md:text-base">Hand-picked premium experiences for our elite members.</p>
          </div>
          <button
            type="button"
            onClick={downloadApk}
            className="text-primary font-bold hover:underline flex items-center gap-1 uppercase tracking-widest text-xs sm:text-sm self-start sm:self-auto"
          >
            Play All <span className="material-icons text-sm">play_circle</span>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8">
          <div className="group relative overflow-hidden rounded-2xl md:rounded-3xl aspect-[4/5]">
            <img
              alt="Royal Roulette"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              src="/assets/welcome/4.png"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-darker via-transparent to-transparent opacity-90" />
            <div className="absolute bottom-0 left-0 p-5 md:p-8">
              <h3 className="text-lg md:text-2xl font-black mb-1 md:mb-2">ROYALE ROULETTE</h3>
              <p className="text-slate-300 text-xs md:text-sm mb-3 md:mb-4">European rules with a high-stakes twist.</p>
              <button
                type="button"
                onClick={downloadApk}
                className="px-5 py-2 bg-white text-darker rounded-full font-bold text-xs md:text-sm md:transform md:translate-y-12 md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100 transition-all duration-300 flex items-center gap-1"
              >
                <span className="material-icons text-sm">play_arrow</span> Play Now
              </button>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-2xl md:rounded-3xl aspect-[4/5]">
            <img
              alt="Elite Poker"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              src="/assets/welcome/2.png"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-darker via-transparent to-transparent opacity-90" />
            <div className="absolute bottom-0 left-0 p-5 md:p-8">
              <h3 className="text-lg md:text-2xl font-black mb-1 md:mb-2">ELITE POKER</h3>
              <p className="text-slate-300 text-xs md:text-sm mb-3 md:mb-4">Professional tables for true enthusiasts.</p>
              <button
                type="button"
                onClick={downloadApk}
                className="px-5 py-2 bg-white text-darker rounded-full font-bold text-xs md:text-sm md:transform md:translate-y-12 md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100 transition-all duration-300 flex items-center gap-1"
              >
                <span className="material-icons text-sm">play_arrow</span> Play Now
              </button>
            </div>
          </div>

          <div className="sm:col-span-2 md:col-span-1 group relative overflow-hidden rounded-2xl md:rounded-3xl aspect-[4/3] sm:aspect-auto md:aspect-[4/5] flex items-center justify-center bg-primary/10 border border-primary/20 min-h-[200px] cursor-pointer hover:bg-primary/20 transition-colors"
            onClick={downloadApk}
          >
            <div className="text-center p-6 md:p-8">
              <div className="w-14 h-14 md:w-20 md:h-20 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <span className="material-icons text-primary text-3xl md:text-4xl">casino</span>
              </div>
              <h3 className="text-lg md:text-2xl font-black mb-2 uppercase">Play &amp; Win</h3>
              <p className="text-slate-400 text-xs md:text-sm mb-4">Over 2,500+ premium slots and live tables waiting for you.</p>
              <button
                type="button"
                onClick={downloadApk}
                className="px-6 py-2.5 bg-primary text-white rounded-full font-bold text-xs md:text-sm uppercase tracking-wider hover:bg-opacity-90 transition-all flex items-center gap-1 mx-auto"
              >
                <span className="material-icons text-sm">download</span> Download APK
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
